<router-outlet tabindex="1" id="rota"></router-outlet>

<app-loading role="text" tabindex="1" id="loader" aria-label="Carregando"></app-loading>